"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _image = require("@site/pattern-library-core/image");
var _ssoDeck = _interopRequireDefault(require("../../../elements/other/sso-deck"));
var _ssoIframe = _interopRequireDefault(require("../../../elements/other/sso-iframe"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
/**
 * Local Imports
 */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-clpsxer"
});
const HeadlineContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineContainer",
  class: "pl-hyh3m1u",
  vars: {
    "hyh3m1u-0": [({
      hasImage
    }) => hasImage ? 'flex-start' : 'center'],
    "hyh3m1u-1": [({
      hasImage
    }) => hasImage ? 'left' : 'center'],
    "hyh3m1u-2": [({
      hasImage
    }) => hasImage ? 'unset' : 'auto'],
    "hyh3m1u-4": [({
      hasImage
    }) => hasImage ? 'right' : 'center']
  }
});
const SsoContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SsoContainer",
  class: "pl-srroc6r"
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "ImageContainer",
  class: "pl-itrnxvl"
});

/**
 * SSOMarquee Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking Name
 * @param {Object} props.image Single Image
 * @param {Boolean} props.reverse Layout
 * @param {String} props.ssoProps SSO Props
 * @param {Object} props.priceLockup Price Lockup
 * @returns {React.ReactElement} SSOMarquee Component
 * @public
 */

function SsoMarquee({
  _name,
  portrait = {},
  landscape = {},
  tabletPortraitBackground = {},
  reverse = false,
  ssoProps,
  legacy = false,
  priceLockup,
  ...rest
}) {
  const hasImage = portrait?.url || landscape?.url || tabletPortraitBackground?.url;
  const ssoCustomProps = {
    customization: {
      hideLogo: true
    }
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    margin: "none",
    padding: "none",
    _name: _name,
    dataCy: "sso-marquee"
  }, /*#__PURE__*/_react.default.createElement(Container, {
    "data-reverse": reverse,
    "data-cy": "container"
  }, /*#__PURE__*/_react.default.createElement(HeadlineContainer, {
    "data-reverse": reverse,
    hasImage: hasImage,
    "data-cy": "headline-container"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    headlineTag: "h2",
    priceLockup: priceLockup
  }, rest)), /*#__PURE__*/_react.default.createElement(SsoContainer, {
    "data-cy": "sso-container",
    hasImage: hasImage
  }, legacy ? /*#__PURE__*/_react.default.createElement(_ssoIframe.default, (0, _extends2.default)({
    pageToLoadData: ssoCustomProps
  }, ssoProps)) : /*#__PURE__*/_react.default.createElement(_ssoDeck.default, (0, _extends2.default)({
    pageToLoadData: ssoCustomProps
  }, ssoProps)))), hasImage && /*#__PURE__*/_react.default.createElement(ImageContainer, {
    landscape: landscape?.url,
    portrait: portrait?.url,
    tablet: tabletPortraitBackground?.url,
    imgLoading: "eager",
    "data-cy": "image-container"
  })));
}
var _default = exports.default = SsoMarquee;
SsoMarquee.propTypes = {
  _name: _propTypes.default.string,
  portrait: _propTypes.default.shape(_image.imgPropShape),
  tabletPortraitBackground: _propTypes.default.shape(_image.imgPropShape),
  landscape: _propTypes.default.shape(_image.imgPropShape),
  reverse: _propTypes.default.bool,
  ssoProps: _propTypes.default.object,
  legacy: _propTypes.default.bool,
  priceLockup: _propTypes.default.object
};